// åæ­¥èª 'rmc-calendar/lib/locale/zh_CN';

export default {
  title: 'æ¥æéæ©',
  today: 'ä»å¤©',
  month: 'æ',
  year: 'å¹´',
  am: 'ä¸å',
  pm: 'ä¸å',
  dateTimeFormat: 'yyyyå¹´MMæddæ¥ ææw hh:mm',
  dateFormat: 'yyyyå¹´MMæddæ¥ ææw',
  noChoose: 'æªéæ©',
  week: ['æ¥', 'ä¸', 'äº', 'ä¸', 'å', 'äº', 'å­'],
  clear: 'æ¸é¤',
  selectTime: 'éæ©æ¶é´',
  selectStartTime: 'éæ©å¼å§æ¶é´',
  selectEndTime: 'éæ©ç»ææ¶é´',
  start: 'å¼å§',
  end: 'ç»æ',
  begin: 'èµ·',
  over: 'æ­¢',
  begin_over: 'èµ·/æ­¢',
  confirm: 'ç¡®è®¤',
  monthTitle: 'yyyyå¹´MMæ',
  loadPrevMonth: 'å è½½ä¸ä¸ä¸ªæ',
  yesterday: 'æ¨å¤©',
  lastWeek: 'è¿ä¸å¨',
  lastMonth: 'è¿ä¸ä¸ªæ'
};
